import React from 'react';
import { createRoot } from 'react-dom/client';
import globModules from './glob-modules';

const reactModule = (Component, nodeList) => {
  nodeList.forEach(node => {
    const root = createRoot(node);
    root.render(<Component {...node.dataset} />);
  });
};

const modules = [
  {
    name: 'accordion',
    loader: () => import('./modules/accordion')
  },
  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal')
  },
  {
    name: 'homepage-masthead',
    loader: () => import('./modules/homepage-masthead')
  },
  {
    name: 'image-slider',
    loader: () => import('./modules/image-slider')
  },
  {
    name: 'media-image-card',
    loader: () => import('./modules/media-image-card')
  },
  {
    name: 'news-listing',
    loader: () => import('./modules/react/news-listing'),
    render: reactModule
  },
  {
    name: 'ytvideo',
    loader: () => import('./modules/ytvideo')
  }
];

export default [...globModules, ...modules];
